import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import moment from 'moment';

import { Dropdown, Typography, Modal, notification, Badge } from 'antd';

import { DownOutlined, FormOutlined, EyeOutlined, CloseOutlined, ExclamationCircleOutlined, TeamOutlined, CalendarOutlined } from '@ant-design/icons';

import Overview from '../../components/overview';

import withErrorHandler from '../../../../hoc/withErrorHandler';
import axios from '../../../../shared/axios/axios';
import newAxios from '../../../../shared/axios/new-api-axios';

import { pipelinePagesTypes } from '../../../../shared/constants/enums/pipelinePagesTypes';
import { siteUrls } from '../../../../shared/constants/siteUrls';
import { opportunityFilter, userTypes } from '../../../../shared/constants/enums';
import { currencyFormatter } from '../../../../shared/utils';
import { generateColumns, fetchData, updateColumnStateBeforeRequest, updateColumnWithData } from '../../helpers/pipelines-overview-helper';

import * as actions from '../../store/actions';
import * as sharedActions from '../../../../shared/store/actions';

import './opportunities-overview-styles.less';
import { isArray, isEmpty } from 'lodash';

const { confirm } = Modal;

let root;

const OpportunitiesOverview = ({ rootContainer, renewalOverview }) => {
  const [shouldInitLoad, setShouldInitLoad] = useState(null);
  const [columns, setColumns] = useState(null);
  const [wonLostColumns, setWonLostColumns] = useState(null);
  const [opportunityStages, setOpportunityStages] = useState(null);
  const [filters, setFilters] = useState(null);
  const [includeRenewal, setIncludeRenewal] = useState(false);

  const userInfo = useSelector((state) => state.shared.userInfo);

  const dispatch = useDispatch();

  const { opportunityStagesLoading, opportunityPipelinesControlConfig, opportunityPipelinesControlConfigLoading, deleteOpportunityLoading } =
    useSelector((state) => state.opportunitiesPipelines);

  useEffect(() => {
    root = rootContainer;

    dispatch(actions.getOpportunityPipelinesControlConfig(renewalOverview)).then((controlConfigRes) => {
      dispatch(actions.getOpportunityStages()).then((res) => {
        if (res && res.length) {
          dispatch(sharedActions.getUserInfo());

          const boundWonOppStageId = 'b6ce9bb6-5a98-4f65-b0a5-f2fceacc2c5a';
          const lostOppStageId = 'b6ce9bb6-5a98-4f65-b0a5-f2fceacc2c56';

          // won and lost bucket hide logic
          const buckets = res.filter((item) => item.id !== boundWonOppStageId && item.id !== lostOppStageId);
          const colsFromBackend = generateColumns(buckets, 'id');
          setOpportunityStages(colsFromBackend);

          const wonLostBucketsFromBacked = [];
          wonLostBucketsFromBacked.push(res.find((item) => item.id === boundWonOppStageId));
          wonLostBucketsFromBacked.push(res.find((item) => item.id === lostOppStageId));

          const wonLostColsFromBackend = generateColumns(wonLostBucketsFromBacked, 'id');
          setWonLostColumns(wonLostColsFromBackend);

          const additionalProps = {
            total: 0,
            renewalOverview: renewalOverview,
          };

          Object.keys(colsFromBackend).forEach((colKey) => {
            Object.assign(colsFromBackend[colKey], additionalProps);

            if (controlConfigRes.columns) {
              const columnFromConfig = controlConfigRes.columns.find((c) => c.id === colKey);

              if (columnFromConfig) {
                colsFromBackend[colKey].order = columnFromConfig.order;
                colsFromBackend[colKey].visible = columnFromConfig.visible;
              }
            }
          });

          setShouldInitLoad(true);

          setColumns(colsFromBackend);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (shouldInitLoad && !!columns && !!userInfo) {
      let tempFilters = {};

      if (userInfo.userType === userTypes.Agent) {
        tempFilters = { assignedTo: 1, agentIds: [userInfo.userId] };
      }

      loadAllData(true, tempFilters);

      setShouldInitLoad(false);
    }
  }, [columns, userInfo]);

  useEffect(() => {
    loadAllData(true, filters);
  }, [includeRenewal]);

  const loadAllData = async (resetPaging, filters) => {
    if (columns) {
      setFilters(filters);

      const updatedColumns = { ...columns };
      const callStack = [];

      Object.keys(updatedColumns).forEach((col) => {
        if (resetPaging) {
          updatedColumns[col].pageNumber = 1;
        }

        updatedColumns[col].loading = true;

        callStack.push({
          pageNumber: updatedColumns[col].pageNumber,
          pageSize: updatedColumns[col].pageSize,
          stageId: updatedColumns[col].status,
          agentIds: filters ? filters.agentIds : [],
          insuredIds: filters?.insuredIds?.length ? filters?.insuredIds : [],
          dueDateRange: filters?.dueDateRange?.length ? filters?.dueDateRange : [],
          opportunityFilter: includeRenewal
            ? opportunityFilter.All
            : updatedColumns[col].renewalOverview
            ? opportunityFilter.CreatedFromRenewal
            : opportunityFilter.CreatedFromNotRenewal,
        });
      });

      if (callStack.length) {
        const filledColumns = await fetchData(
          actions.getOpportunities({ data: callStack }),
          updatedColumns,
          'opportunityStageId',
          true,
          renewalOverview ? pipelinePagesTypes.RenewalOverview : pipelinePagesTypes.OpportunitiesOverview,
        );
        setColumns(filledColumns);
      }
    }
  };

  const refresh = (filters) => {
    loadAllData(true, filters);
  };

  const handleChangeStatus = (sourceCol, destColumn, item, shouldNotUpdateDestColumn) => {
    const updatedColumns = { ...columns };

    Object.keys(updatedColumns).forEach((columnKey) => {
      if (updatedColumns[columnKey].name === sourceCol.name || updatedColumns[columnKey].name === destColumn.name) {
        updatedColumns[columnKey].loading = true;
      }
    });

    setColumns(updatedColumns);

    dispatch(actions.changeOpportunityStage(item.id, destColumn.status)).then(() => {
      if (!shouldNotUpdateDestColumn) {
        handleLoadSingleBucketData(destColumn, true);
      }

      handleLoadSingleBucketData(sourceCol, true);
    });
  };

  const handleLoadSingleBucketData = (column, resetPage) => {
    const updatedColumns = { ...columns };

    const columnKeyToEdit = Object.keys(updatedColumns).find((key) => updatedColumns[key].name === column.name);

    updateColumnStateBeforeRequest(updatedColumns, columnKeyToEdit, resetPage);

    actions
      .getOpportunities({
        data: [
          {
            pageNumber: updatedColumns[columnKeyToEdit].pageNumber,
            pageSize: updatedColumns[columnKeyToEdit].pageSize,
            stageId: updatedColumns[columnKeyToEdit].status,
            agentIds: filters ? filters.agentIds : [],
            opportunityFilter: includeRenewal
              ? opportunityFilter.All
              : updatedColumns[columnKeyToEdit].renewalOverview
              ? opportunityFilter.CreatedFromRenewal
              : opportunityFilter.CreatedFromNotRenewal,
          },
        ],
      })
      .then((result) => {
        updateColumnWithData(isArray(result) && !isEmpty(result) ? result[0] : undefined, updatedColumns, resetPage, columnKeyToEdit, true);

        setColumns(updatedColumns);
      });
  };

  const handleUpdateColumnsState = (updatedColumns) => {
    setColumns(updatedColumns);
  };

  const handleDeleteOpportunity = (item, column) => {
    dispatch(actions.deleteOpportunity(item.id)).then((res) => {
      if (res) {
        handleLoadSingleBucketData(column, true);

        notification.success({
          message: 'Success',
          top: 55,
          duration: 10,
          getContainer: rootContainer,
          description: 'Opportunity was successfully deleted',
        });
      }
    });
  };

  const renderBucketItem = (item, column) => {
    let pipelineItem = (
      <div className="opportunities-pipeline-item pipeline-item">
        <div className="opportunities-pipeline-item-header">
          <span title={'Insured'} className="text-ellipsis">
            {!!item.insuredName ? (
              <a
                title={item.insuredName.trim()}
                className="insured"
                href={siteUrls.getTruckingCompanyDetailsUrl(
                  opportunityPipelinesControlConfig?.isMomentumEnabled,
                  item.truckingCompanyId,
                  item.insuredType,
                )}
              >
                {item.insuredName.trim()}
              </a>
            ) : (
              'N/A'
            )}
          </span>

          {renderActionsMenu(item, column)}
        </div>

        <p style={{ marginBottom: '7px', fontSize: '12px' }}>
          <Typography.Text type="secondary" title="Line of Business">
            {item.lineOfBusiness}
          </Typography.Text>
        </p>

        {isArray(item.policies) && !isEmpty(item.policies) ? (
          <p style={{ marginBottom: '7px', fontSize: '12px' }}>
            <Typography.Text title={'Assigned agents'} type="secondary">
              {'Policies: '}
              {item.policies.map((policy, index) => (
                <span key={index}>
                  <a href={`${siteUrls.getPolicyDetailsUrl(opportunityPipelinesControlConfig?.isMomentumEnabled, policy.id, policy.isQuote)}`}>
                    {`${policy.number}`.trim()}
                  </a>
                  {item.policies.length - 1 !== index ? ', ' : ' '}
                </span>
              ))}
            </Typography.Text>
          </p>
        ) : undefined}

        <p style={{ marginBottom: '7px', fontSize: '12px' }}>
          <Typography.Text type="secondary" title="Description">
            {item.description}
          </Typography.Text>
        </p>

        <p style={{ marginBottom: '10px', fontSize: '12px' }}>
          <Typography.Text title={'Assigned agents'} type="secondary">
            <TeamOutlined style={{ marginRight: '5px' }} />
            {item.agents && item.agents.length
              ? item.agents.map((agent, index) => {
                  return (
                    <span key={agent.id}>
                      <a href={`${siteUrls.getAgentDetailsUrl(opportunityPipelinesControlConfig?.isMomentumEnabled, agent.id)}`}>
                        {`${agent.firstName} ${agent.lastName}`.trim()}
                      </a>
                      {item.agents.length - 1 !== index ? ', ' : ' '}
                    </span>
                  );
                })
              : 'N/A'}
          </Typography.Text>
        </p>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="text-info" title='Estimated Revenue'>{currencyFormatter(item.estimatedRevenue)}</span>

          <Typography.Text title={'Due date'} type="secondary" style={{ fontSize: '11px' }}>
            <CalendarOutlined style={{ marginRight: '5px' }} />
            {moment(item.dueDate).format('MMM DD YYYY')}
          </Typography.Text>
        </div>
      </div>
    );

    if (!renewalOverview && item.createdFromRenewal) {
      pipelineItem = (
        <Badge.Ribbon text="Renewal" color="cyan">
          {pipelineItem}
        </Badge.Ribbon>
      );
    }

    return pipelineItem;
  };

  const renderActionsMenu = (item, column) => {
    const menu = [
      {
        key: item.id + 1,
        label: (
          <a href={siteUrls.getEditOpportunityUrl(opportunityPipelinesControlConfig?.isMomentumEnabled, item.id)}>
            <FormOutlined style={{ marginRight: '8px' }} />
            Edit
          </a>
        ),
      },
      {
        key: item.id + 2,
        label: (
          <a href={siteUrls.getOpportunityDetailsUrl(opportunityPipelinesControlConfig?.isMomentumEnabled, item.id)}>
            <EyeOutlined style={{ marginRight: '8px' }} />
            Details
          </a>
        ),
      },
      {
        key: item.id + 3,
        onClick: () => showDeleteConfirm(item, column),
        label: (
          <>
            <CloseOutlined style={{ marginRight: '8px' }} />
            Delete
          </>
        ),
      },
    ];

    return (
      <Dropdown menu={{ items: menu }} trigger={['click']} getPopupContainer={rootContainer} placement="bottom">
        <DownOutlined style={{ fontSize: '10px' }} />
      </Dropdown>
    );
  };

  const showDeleteConfirm = (item, column) => {
    confirm({
      getContainer: rootContainer,
      title: 'Are you sure you want to delete this opportunity?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      confirmLoading: deleteOpportunityLoading,
      okButtonProps: { disabled: deleteOpportunityLoading },
      onOk() {
        return handleDeleteOpportunity(item, column);
      },
    });
  };

  const saveControlConfiguration = (columnsConfig) => {
    dispatch(actions.saveOpportunityPipelinesControlConfig(renewalOverview, columnsConfig));
  };

  return (
    <div className="opportunities-overview">
      <Overview
        configuratorEnabled={true}
        saveControlConfiguration={saveControlConfiguration}
        showTotals={true}
        columns={columns}
        renderBucketItem={renderBucketItem}
        type={renewalOverview ? pipelinePagesTypes.RenewalOverview : pipelinePagesTypes.OpportunitiesOverview}
        userInfo={userInfo}
        isLoading={opportunityPipelinesControlConfigLoading || opportunityStagesLoading}
        refresh={refresh}
        changeStatus={handleChangeStatus}
        loadSingleBucketData={handleLoadSingleBucketData}
        rootContainer={rootContainer}
        updateColumnsState={handleUpdateColumnsState}
        fetchData={loadAllData}
        wonLostColumns={wonLostColumns}
        linkToList={siteUrls.getOpportunitiesListUrl(opportunityPipelinesControlConfig?.isMomentumEnabled)}
        setIncludeRenewal={setIncludeRenewal}
        isMomentumEnabled={opportunityPipelinesControlConfig?.isMomentumEnabled}
        canViewOnlyAssigned={opportunityPipelinesControlConfig?.canViewOnlyAssigned}
      />
    </div>
  );
};

export default connect(null, null)(hot(withErrorHandler(OpportunitiesOverview, axios, root, newAxios)));
